import { Grid } from 'antd'
import { Sparkles } from 'lucide-react'
import { useState } from 'react'
import { NoraWidget } from '../NoraWidget'
import type { NoraFloatingButtonProps } from './NoraFloatingButton.props'
import * as S from './styles'

export function NoraFloatingButton ({
  isOpen: controlledIsOpen, onToggle, buttonContent, buttonStyle, initialPrompt
}: NoraFloatingButtonProps): React.ReactElement {
  const [internalIsOpen, setInternalIsOpen] = useState(false)
  const screens = Grid.useBreakpoint()
  const isMobile = screens.md === false
  const isOpen = controlledIsOpen ?? internalIsOpen
  const toggle = (open: boolean): void => {
    if (onToggle) onToggle(open)
    else setInternalIsOpen(open)
  }

  return <>
    {!isOpen && controlledIsOpen === undefined && <S.FloatingButton
      type="button" aria-label="Abrir Nora" onClick={() => toggle(true)} style={buttonStyle}
    >{buttonContent ?? <Sparkles size={24} color="white" />}</S.FloatingButton>}
    <S.ChatDialog
      open={isOpen} onCancel={() => toggle(false)} footer={null} centered={!isMobile}
      width={1000} closable={false} aria-label="Nora, assistente regulatória"
      transitionName={isMobile ? 'nora-sheet' : undefined}
      styles={{
        container: {
          padding: 0,
          border: '1px solid #dfe6f0',
          borderRadius: isMobile ? '16px 16px 0 0' : 12,
          overflow: 'hidden'
        },
        body: {
          height: isMobile ? '92dvh' : 'min(760px, 90dvh)',
          padding: 0,
          paddingBottom: isMobile ? 'env(safe-area-inset-bottom, 0px)' : 0,
          boxSizing: 'border-box'
        }
      }}
    >
      <NoraWidget initialPrompt={initialPrompt} active={isOpen} onClose={() => toggle(false)} />
    </S.ChatDialog>
  </>
}

export default NoraFloatingButton
